import React from "react";
import ProjectSummery from "./projectSummery";
import { Link } from "react-router-dom";
const ProjectList = ({ tasks }) => {
  return (
    <div className="project-list section">
      {tasks &&
        tasks.map((task) => {
          return (
            <Link to={"/task/" + task.id} key={task.id}>
              <ProjectSummery task={task} />
            </Link>
          );
        })}
    </div>
  );
};
export default ProjectList;
